<template>
  <div class="panel">
    <div class="panel-body">
      <q-list-header>
        Заявки ({{items.length}})
      </q-list-header>
      <div v-for="(item, ind) in items" :key="item.id" class="panel panel-gray">
        <div class="panel-header">
          <div class="panel-title"><q-icon name="fa-bell"/><span> {{item.date}}</span></div>
          <q-btn
              v-if="allowDelete && (isAdmin || (isDispatcher && item.handled))"
              @click="doDelete(item)"
              :color="item.handled ? 'positive':'negative'"
              icon="delete_forever"
              round
              flat
              title="Удалить"
          />
          <q-btn
              v-if="instrumentId && isDispatcher"
              @click="$router.push('/icnew/' + instrumentId + '/' + item._id)"
              icon="fa-briefcase"
              round
              flat
              title="Создать кейс по заявке"
              color="positive"
          />
          <q-btn
              v-if="linkingEnabled"
              @click="linkToCase(item)"
              color="primary"
              icon="fa-link"
              round
              flat
              title="Связать с кейсом"
          />
        </div>
        <div class="panel-body">
          <p>
            <small class="view-label">Пин-код</small>
            <span class="text-bolder">{{item.pin}}</span>
          </p>
          <p>
            <small class="view-label">Клиент</small>
            <span class="text-bolder">{{item.hospital}}</span>
            <q-btn
                @click="doSearch(ind, 'hospital')"
                color="primary"
                icon="search"
                size="sm"
                dense
                round
                flat
                title="Искать"
            />
          </p>
          <p>
            <small class="view-label">Место</small>
            <span class="text-bolder">{{item.place}}</span>
            <q-btn
                @click="doSearch(ind, 'place')"
                color="primary"
                icon="search"
                size="sm"
                dense
                round
                flat
                title="Искать"
            />
          </p>
          <p>
            <small class="view-label">Прибор</small>
            <span class="text-bolder">{{item.analyzer}}</span>
            <q-btn
                @click="doSearch(ind, 'analyzer')"
                color="primary"
                icon="search"
                size="sm"
                dense
                round
                flat
                title="Искать"
            />
          </p>
          <p>
            <small class="view-label">Проблема</small>
            <span class="text-bolder">{{item.defect}}</span>
          </p>
          <p>
            <small class="view-label">Контакт</small>
            <span class="text-bolder">{{item.person}}</span>
            <q-btn
                @click="doSearch(ind, 'person')"
                color="primary"
                icon="search"
                size="sm"
                dense
                round
                flat
                title="Искать"
            />
          </p>
          <p>
            <small class="view-label">Телефон</small>
            <span class="text-bolder">{{item.telephone}}</span>
            <q-btn
                @click="doSearch(ind, 'telephone')"
                color="primary"
                icon="search"
                size="sm"
                dense
                round
                flat
                title="Искать"
            />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import utils from '../others/utils.js';

export default {
  name: 'requestlist',
  components: {},
  props: ['items', 'instrumentId'],
  computed: {
    allowDelete() {
      return this.$route.name !== 'caseNewFromRequest';
    },
    linkingEnabled() {
      if (!this.$store.getters.isDispatcher) {
        return false;
      }
      if (this.$route.name !== 'instrumentCaseView' && this.$route.name !== 'caseView') {
        return false;
      }
      const _case = this.$store.state.cases[this.$route.params.id];
      if (_case.raw) {
        return false;
      }

      return true;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDispatcher() {
      return this.$store.getters.isDispatcher;
    },
  },
  methods: {
    doSearch(ind, field) {
      const _term = utils.normalizeStr(this.items[ind][field]);
      let where;
      switch (field) {
        case 'hospital':
          where = 'h';
          break;
        case 'place':
          where = 'd';
          break;
        case 'analyzer':
          where = 'i';
          break;
        case 'person':
          where = 'p';
          break;
        case 'telephone':
          where = 't';
          break;
        default:
      }
      this.$store.commit('setSearchQuery', { where, term: _term });
      this.$router.push('/search');
    },
    linkToCase(item) {
      const _case = this.$store.state.cases[this.$route.params.id];
      this.$q.dialog({
        title: 'Подтвердите связывание',
        'prevent-close': true,
        message: `Заявка полученная ${item.date} (пин-код ${item.pin}) будет связана с кейсом №${_case.num}!`,
        ok: {
          flat: true,
          color: 'warning',
          label: 'Связать',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => {
          const requestToRaw = this.$copy(item);
          delete requestToRaw._id;
          delete requestToRaw._rev;
          _case.raw = requestToRaw;
          return this.$store.dispatch('saveUnit', _case);
        })
        .then(() => {
          if (!item.handled) {
            return this.$store.dispatch('saveUnit', this.$copy(item, { handled: true }));
          }
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    doDelete(item) {
      if (item.handled) {
        // delete without confirmation
        this.$store.dispatch('deleteUnit', item);
      } else {
        this.$q.dialog({
          title: 'Подтвердите удаление',
          'prevent-close': true,
          message: `Заявка полученная ${item.date} (пин-код ${item.pin}) будет удалена БЕЗ СОЗДАНИЯ КЕЙСА!`,
          ok: {
            flat: true,
            color: 'negative',
            label: 'Удалить',
          },
          cancel: {
            flat: true,
            color: 'info',
            label: 'Отмена',
          },
        })
          .then(() => {
            this.$store.dispatch('deleteUnit', item);
          })
          .catch((err) => {
            if (err) console.log(err);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/requests-list.vue